import { CalendarDots } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import useLinkedInEvents from "../../../datahooks/useLinkedInEvents";

interface GroupTargetingLabelsProps {
  eventId: string;
  isLoading: boolean;
}

export default function EventTargetingLabel({
  eventId,
  isLoading,
}: GroupTargetingLabelsProps) {
  const { linkedInEvent, isLoadingLinkedInEvent } = useLinkedInEvents({
    eventId,
  });

  if (isLoading || isLoadingLinkedInEvent)
    return <Skeleton className="h-7 w-60" />;

  return (
    <Tag
      size="md"
      variant="primary-black"
      leftIcon={<CalendarDots weight="fill" />}
      className="max-w-full"
    >
      {linkedInEvent ? linkedInEvent.name : "LinkedIn Event"}
    </Tag>
  );
}
